interface AddSpaceProps {
  vSpace: string,
  hSpace: string
}

const AddSpace = ({ vSpace='100vh', hSpace='100vw' }: AddSpaceProps) => {

  const styles = {
    width: hSpace,
    height: vSpace,
    padding: '0px',
    margin: '0px',
    background: 'transparent'
  }

  return (
    <section className="addSpace" style={styles}></section>
  )
}

export default AddSpace